<img class="confetti" src="/assets/images/confetti.svg"/>